<div>
  <app-nav-bar>
    <main>
      <div class="account-container">
        <div class="mt-5">
          <div class="card-box">
            <div class="card-body">
              <h5>Meus dados</h5>

              <div *ngIf="!isMobile; else mobileView">
                <mat-tab-group class="mt-3">
                  <mat-tab label="Dados da Empresa">
                    <app-company-details
                      [cpoData]="corporateAccount"
                    ></app-company-details>
                  </mat-tab>
                  <mat-tab label="Sócios">
                    <app-company-partners
                      [partnerData]="corporateAccount?.companyResponsibles"
                    ></app-company-partners>
                  </mat-tab>
                  <mat-tab label="Conta bancária">
                    <app-company-accounts></app-company-accounts>
                  </mat-tab>
                </mat-tab-group>
              </div>
              <ng-template #mobileView>
                <div class="mb-4">
                  <h5>Dados da Empresa</h5>
                  <app-company-details
                    [cpoData]="corporateAccount"
                  ></app-company-details>
                </div>

                <div class="mb-4">
                  <h5>Sócios</h5>
                  <app-company-partners
                    [partnerData]="corporateAccount?.companyResponsibles"
                  ></app-company-partners>
                </div>

                <div class="mb-4">
                  <h5>Conta bancária</h5>
                  <app-company-accounts></app-company-accounts>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </main>
  </app-nav-bar>
</div>
